/**
 * localStorage key and teardown for the Traffic Inspector's persisted event feed.
 *
 * Split out of TrafficStreamContext so the logout path can purge the feed without
 * importing the React context (and, with it, the whole traffic-inspector API
 * surface) into the auth module.
 *
 * SEC-I1, extending SEC-04's logout purge to this feed. The persisted feed is not
 * metadata: an event carries the request's tool results, and #112 measured single
 * chart results at hundreds of kilobytes — real chart content for a real patient,
 * sitting in localStorage under a 4 MB budget. Nothing removed it.
 * `purgeAllThreadStorage` only knows about thread keys and
 * `reconcileClinicianScope`'s wipe list only knows about SMART keys, so on a shared
 * clinical workstation this feed outlived the sign-out that was supposed to end the
 * clinician's session, and remained readable — via the Traffic Inspector or the
 * console — by whoever sat down next.
 */

export const MARCH_EVENT_STORAGE_KEY = 'march.trafficInspector.events.v2';

/** Drop the persisted feed. Best-effort: storage may be unavailable or full. */
export function purgePersistedTrafficEvents(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(MARCH_EVENT_STORAGE_KEY);
  } catch {
    // Best-effort teardown, matching the other purge helpers.
  }
}
